<template>
    <div class="component-myUpload">
        <a-form-model-item>
            <a-upload key="upload-img" list-type="picture-card"
                accept=".jpg,.jpeg,.png" :multiple="false"
                :file-list="imgList" :before-upload="beforeUpload"
                :custom-request="handleUploadImg" @remove="handleRemoveImg"
            >
                <div v-if="imgList.length < 1">
                    <img src="https://p1.ssl.qhimg.com/t110b9a930191e51991e2b20ae1.png" alt="" />
                </div>
            </a-upload>
        </a-form-model-item>
        <div class="upload-tishi">
            <div class="tishi-title">{{ showTishi }}</div>
            <p class="tishi-desc">支持 jpg、png 格式，大小不超过 2M</p>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { uploadImg } from '@/api/2025'
import { ElMessage } from 'element-plus';
import piexif from 'piexifjs';

const props = defineProps({
    showTishi: {
        type: String,
        default: "请上传您的头像"
    }
})

const emit = defineEmits(["upload","remove"]);

let imgList = ref([]);

const beforeUpload = (file) => {
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
        ElMessage.error('图片大小不超过2M!');
    }
    return isLt2M;
}
const handleUploadImg = (uploader) => {
  const file = uploader.file
  console.log('上传的文件', file)
  // 只处理 JPEG
  if (!file.type.includes('jpeg') && !file.type.includes('jpg')) {
    console.warn('不是 JPEG 图片，跳过 EXIF 分析')
    // 继续上传
    uploadImg(file).then(res => {
        if (res.data.msg == "SUCCESS") {
            file.url = res.data.data.imageurl
            imgList.value =[file]
            uploader.onSuccess(res.data.data.imageurl)
        } else {
            ElMessage.error(res.data.msg)
            uploader.onError()
        }
        emit('upload', imgList.value,1)
    })
    return false
  }

  const reader = new FileReader()
  reader.onload = function (e) {
    const dataUrl = e.target.result

    try {
      const exifObj = piexif.load(dataUrl)
      const orientation = exifObj["0th"][piexif.ImageIFD.Orientation]
    //   console.log('EXIF Orientation:', orientation)
      // 可在此处添加基于 orientation 的图像旋转处理逻辑

      // 然后调用上传逻辑
      return uploadImg(file).then(res => {
        if (res.data.msg == "SUCCESS") {
            file.url = res.data.data.imageurl
            imgList.value =[file]
            uploader.onSuccess(res.data.data.imageurl)
        } else {
            ElMessage.error(res.data.msg)
            uploader.onError()
        }
        emit('upload', imgList.value,orientation)
    })

    } catch (error) {
      console.error('读取 EXIF 出错', error)
      // 继续上传
      return uploadImg(file).then(res => {
        if (res.data.msg == "SUCCESS") {
            file.url = res.data.data.imageurl
            imgList.value =[file]
            uploader.onSuccess(res.data.data.imageurl)
        } else {
            ElMessage.error(res.data.msg)
            uploader.onError()
        }
        emit('upload', imgList.value,orientation)
    })
    }
  }

  reader.readAsDataURL(file)

  return false
}
const handleRemoveImg = () => {
    imgList.value = [];
    emit('remove', imgList.value)
}
</script>

<style lang="scss" scoped>
.component-myUpload{
    display: flex;
    align-items: center;
    gap: 20px;
    :deep(.ant-form-item-control) {
        line-height: 0;
    }
    :deep(.ant-form-item) {
        margin-bottom: 0px;
    }
    :deep(.ant-upload.ant-upload-select-picture-card) {
        // border-radius: 50%;
        margin-bottom: 0px;
        margin-right: 0px;
    }
    :deep(.ant-upload.ant-upload-select-picture-card:hover) {
        border-color: rgb(25, 104, 255);
    }
    :deep(.ant-upload-list-picture-card-container) {
        margin: 0 0 0 0;
    }
    .upload-tishi{
        height: 109px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .tishi-title{
            color: rgb(44, 44, 44);
            font-family: Source Han Sans;
            font-size: 16px;
            font-weight: 500;
            line-height: 16px;
            letter-spacing: 0px;
        }
        .tishi-desc{
            color: rgb(177, 176, 176);
            font-family: Source Han Sans;
            font-size: 14px;
            font-weight: 400;
            line-height: 16px;
            letter-spacing: 0px;
            margin-top: 16px;
        }
    }
}
</style>